module.exports = __webpack_public_path__ + "static/AddGrid-259355d3111bf3ba5980779da86d4e07.png";